<ng-container *ngrxLet="{ isTest: isTest$ } as vm">
    <h1>{{ "helpdeskToolkitLib.isTestLabel" | transloco }}</h1>
    <span>{{ vm.isTest }}</span>
</ng-container>
